var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6666 0.666016H4.99992C2.43325 0.666016 0.356586 2.76602 0.356586 5.33268L0.333252 42.666C0.333252 45.2327 2.40992 47.3327 4.97658 47.3327H32.9999C35.5666 47.3327 37.6666 45.2327 37.6666 42.666V14.666L23.6666 0.666016ZM28.3333 33.3327H21.3333V40.3327H16.6666V33.3327H9.66658V28.666H16.6666V21.666H21.3333V28.666H28.3333V33.3327ZM21.3333 16.9993V4.16602L34.1666 16.9993H21.3333Z",
    fill: "#495057",
    fillOpacity: 0.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add_file.a9631d45.svg";
export { ForwardRef as ReactComponent };